import { RecentCheckedItemRepository } from '../../repositories/recent_checked_item/recent_checked_item_repository';
import { RecentCheckedItem } from '../../models/recent_checked_item/recent_checked_item';
import { RecentCheckedItemJsEnv } from '../../models/recent_checked_item/recent_checked_item_js_env';
import { TypedEvent } from '../../typed_event';
import { RecentCheckedItemContainer } from '../../views/pc/recent_checked_item/recent_checked_item_container';
import { JsEnv } from '../../models/js_env';

export class RecentCheckedItemAction {
  static readonly UPDATE_EVENT = new TypedEvent<RecentCheckedItemJsEnv>();
  private static state: RecentCheckedItem;
  private static recentCheckedItemRepository: RecentCheckedItemRepository;
  static async init(env: JsEnv) {
    this.recentCheckedItemRepository = new RecentCheckedItemRepository();
    this.state = new RecentCheckedItem(
      await this.recentCheckedItemRepository.getRecentCheckedItems(env.SITE_TYPE, env.PAGE.isLogin));
    new RecentCheckedItemContainer(this.state.getModel());// NOSONAR
  }

  static async delete(supplierId: string, catalogItemCode: string) {
    const model = this.state.getModel()
    await this.recentCheckedItemRepository.delete(model.siteType, model.isLogin, supplierId, catalogItemCode);

    this.state.updateModel(
      supplierId,
      catalogItemCode);

    // いったん、削除ボタン押下時のDOMの書き換えは、デザイン側のJS（common.js）で行うことに。
    // 将来的にこちらも利用するかもしれないため、削除ではなくコメントアウトしている。
    // this.UPDATE_EVENT.trigger(this.state.getModel())
  }
}
